import { styled } from "@mui/material";

export const Styled = {
    Container: styled("div")`
        flex: 1;
        display: flex;
    `,
    List: styled("ul")`
        padding: 50px 100px;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(min-content, 230px));
        gap: 20px;
        width: 100%;
        ${props => props.theme.breakpoints.down("sm")} {
            padding: 0;
            margin: 50px auto;
            flex-direction: column;
        }
    `,
};
